module.exports = __webpack_public_path__ + "static/media/opera.99beeb26.svg";